import common from './slfuntapTheme/commonStyle.oci';

import landscape from './slfuntapTheme/landscape.oci';
import portrait from './slfuntapTheme/portrait.oci';

export let commonStyles = common;
export let landscapeStyle = landscape;
export let portraitStyles = portrait;
